import { render } from "./App.vue?vue&type=template&id=016e5b54"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=016e5b54&lang=css"
/* custom blocks */
import block0 from "./App.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(script)
import block1 from "./App.vue?vue&type=custom&index=1&blockType=title"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__